export function ConvertOIDValueToString(objectOID, value) {
  const enumDataStr = localStorage.getItem("enumData");
  const enumData = JSON.parse(enumDataStr);

  var returnStr = "";

  if (value == null || value == undefined) {
    returnStr = null;
    return returnStr;
  }
  const currentLang = localStorage.getItem("i18nextLng") || "en";

  switch (objectOID.type) {
    case 1: // ENUM
      var oidEnum = enumData.find((item) => item.idEnum == value);
      if (oidEnum) {
        if (currentLang === "tr") {
          returnStr = oidEnum.name1;
        } else if (currentLang === "de") {
          returnStr = oidEnum.name3;
        } else {
          returnStr = oidEnum.name2;
        }
      } else {
        returnStr = "UNKNOWN";
      }
      break;

    case 0: // BOOL
      returnStr = value === "1" || value === 1 ? "TRUE" : "FALSE";
      break;

    case 2: // INTEGER
    case 3: // SHORT_STRING
    case 4: // IP
    case 6: // LONG_STRING
    case 7: // HOST
    case 8: // SEKIZBIT
    case 9: // ONALTINBIT
      returnStr = value.toString();
      break;

    case 5: // FLOAT
      let floatVal = parseFloat(value);
      returnStr = !isNaN(floatVal) ? floatVal.toString() : "-999.0";
      break;

    case 10: // (INT1000)
      let intBinResult = -999.0;
      if (!isNaN(parseInt(value))) {
        intBinResult = parseInt(value);
        returnStr = (intBinResult / 1000.0).toString();
      } else {
        returnStr = intBinResult.toString();
      }
      break;

    case 11: // (INT100)
      let intYuzResult = -999.0;
      if (!isNaN(parseInt(value))) {
        intYuzResult = parseInt(value);
        returnStr = (intYuzResult / 100.0).toString();
      } else {
        returnStr = intYuzResult.toString();
      }
      break;

    case 12: // (INT10)
      let intOnResult = -999.0;
      if (!isNaN(parseInt(value))) {
        intOnResult = parseInt(value);
        returnStr = (intOnResult / 10.0).toString();
      } else {
        returnStr = intOnResult.toString();
      }
      break;

    default:
      returnStr = value.toString();
      break;
  }

  return returnStr;
}

export function ConvertStringValueToOID(objectOID, displayValue) {
  const enumDataStr = localStorage.getItem("enumData");
  const enumData = JSON.parse(enumDataStr);

  if (
    displayValue === null ||
    displayValue === undefined ||
    displayValue === ""
  ) {
    return null;
  }

  const currentLang = localStorage.getItem("i18nextLng") || "en";

  switch (objectOID.type) {
    case 1: // ENUM
      // Find enum by display name based on current language
      let foundEnum = null;
      if (currentLang === "tr") {
        foundEnum = enumData.find((item) => item.name1 === displayValue);
      } else if (currentLang === "de") {
        foundEnum = enumData.find((item) => item.name3 === displayValue);
      } else {
        foundEnum = enumData.find((item) => item.name2 === displayValue);
      }

      if (foundEnum) {
        return foundEnum.idEnum.toString();
      } else {
        // If not found by display name, try to parse as direct enum ID
        return displayValue.toString();
      }

    case 0: // BOOL
      if (
        displayValue === "TRUE" ||
        displayValue === "true" ||
        displayValue === "1"
      ) {
        return "1";
      } else if (
        displayValue === "FALSE" ||
        displayValue === "false" ||
        displayValue === "0"
      ) {
        return "0";
      }
      return displayValue.toString();

    case 2: // INTEGER
    case 3: // SHORT_STRING
    case 4: // IP
    case 6: // LONG_STRING
    case 7: // HOST
    case 8: // SEKIZBIT
    case 9: // ONALTINBIT
      return displayValue.toString();

    case 5: // FLOAT
      return displayValue.toString();

    case 10: // (INT1000) - Convert back by multiplying by 1000
      let floatVal = parseFloat(displayValue);
      if (!isNaN(floatVal)) {
        return Math.round(floatVal * 1000).toString();
      }
      return displayValue.toString();

    case 11: // (INT100) - Convert back by multiplying by 100
      let floatVal100 = parseFloat(displayValue);
      if (!isNaN(floatVal100)) {
        return Math.round(floatVal100 * 100).toString();
      }
      return displayValue.toString();

    case 12: // (INT10) - Convert back by multiplying by 10
      let floatVal10 = parseFloat(displayValue);
      if (!isNaN(floatVal10)) {
        return Math.round(floatVal10 * 10).toString();
      }
      return displayValue.toString();

    default:
      return displayValue.toString();
  }
}

export default ConvertOIDValueToString;
